import {
    Box,
    Card,
    Flex,
    Grid,
    Skeleton,
    SkeletonCircle,
} from "@chakra-ui/react";

const skeletonProps = {
    bg: "#DAE9FF",
    borderRadius: "md",
};

const cardProps = {
    bg: "white",
    border: "none",
    borderWidth: 0,
    boxShadow: "sm",
    borderRadius: "2xl",
};

const PolicyCardSkeleton = () => (
    <Card.Root {...cardProps}>
        <Card.Body
            p={{
                base: 5,
                md: 6,
            }}
        >
            <Flex
                justify="space-between"
                align="flex-start"
                mb={5}
            >
                <SkeletonCircle
                    bg="#DAE9FF"
                    size="12"
                />

                <Skeleton
                    {...skeletonProps}
                    h="30px"
                    w="30px"
                    borderRadius="full"
                />
            </Flex>

            <Skeleton
                {...skeletonProps}
                h="22px"
                w="75%"
                mb={4}
            />

            <Skeleton
                {...skeletonProps}
                h="12px"
                w="100%"
                mb={2}
            />

            <Skeleton
                {...skeletonProps}
                h="12px"
                w="92%"
                mb={2}
            />

            <Skeleton
                {...skeletonProps}
                h="12px"
                w="65%"
                mb={6}
            />

            <Flex
                justify="space-between"
                align="center"
            >
                <Skeleton
                    {...skeletonProps}
                    h="14px"
                    w="90px"
                />

                <Skeleton
                    {...skeletonProps}
                    h="14px"
                    w="70px"
                />
            </Flex>
        </Card.Body>
    </Card.Root>
);

export default function TermsPoliciesSkeleton() {
    return (
        <>
            {/* Header */}

            <Box
                mb={{
                    base: 6,
                    md: 8,
                }}
            >
                <Skeleton
                    {...skeletonProps}
                    h="36px"
                    w={{
                        base: "220px",
                        md: "320px",
                    }}
                    mb={3}
                />

                <Skeleton
                    {...skeletonProps}
                    h="16px"
                    w={{
                        base: "100%",
                        md: "650px",
                    }}
                />
            </Box>

            {/* Policy Cards */}

            <Grid
                templateColumns={{
                    base: "1fr",
                    sm: "repeat(2,1fr)",
                    xl: "repeat(3,1fr)",
                }}
                gap={{
                    base: 4,
                    md: 6,
                }}
            >
                {Array.from({
                    length: 6,
                }).map((_, i) => (
                    <PolicyCardSkeleton
                        key={i}
                    />
                ))}
            </Grid>
        </>
    );
}